export const baseApiUrl = `${__jsVars.url.api}v1/`;

export const paths = {
    newsletter: `${baseApiUrl}newsletter/save`,
    form: `${baseApiUrl}contact-form`,
};
